<template>
  <main id="vehicle-manage">
    <section class="control-page-common vehicle-manage-wrapper">
      <div class="console-title title-flex">
        <div class="title-default">车辆导入</div>
        <!-- <el-common-video
          href="https://mgate.didistatic.com/static/mgate/do1_XKZUKvKzrVJHXKU9tAeh"
        ></el-common-video> -->
      </div>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="批量导入" name="batch">
          <el-batch-import
            uploadUrl="upload/vehicle/batch"
            buttonName="确定批量导入"
            requestUrl="fileUpload/result"
            keys="fileGiftKey"
            confirmSuccessRouterTxt="车辆查询"
            pathName="vehicleQuery"
            successTxt="批量导入成功"
            messageType="message"
          >
            <div slot="title_info" class="common-batch-import_title_info">
              <p style="color:#858b9c">
                单次最大导入限20M以内，请按模版要求填写
                <a
                  href="https://mgate.didistatic.com/static/mgate/do1_RMIvGSfSUCyxlbv1ILSx"
                  >模版下载</a
                >
              </p>
            </div>
          </el-batch-import>
        </el-tab-pane>
        <el-tab-pane label="单个导入" name="single">
          <el-single-import ref="singImport" />
        </el-tab-pane>
      </el-tabs>
    </section>
    <el-row class="fixed-btn-wrapper" v-if="activeName === 'single'">
      <el-button type="primary" class="medium-small" @click="singImport"
        >导入</el-button
      >
    </el-row>
  </main>
</template>

<script>
import batchImport from '../../components/console-common/batch-import-polling.vue'
import singleImport from '../../components/vehicle-manage/single-import.vue'
import commonVideo from '../../components/console-common/common-video.vue'
import { saveData, getData } from '../../utils/storage'
export default {
  components: {
    'el-batch-import': batchImport,
    'el-single-import': singleImport,
    'el-common-video': commonVideo,
  },
  data() {
    return {
      activeName: 'batch',
      popoverVisible: false,
      batchhImport: {
        buttonName: '确定批量导入',
        requestUrl: '/proxy/vehicle/file/file/upload/vehicle/batch',
        pathName: '车辆管理-车辆查询',
        path: '/console/vehicle/query',
      },
    }
  },
  methods: {
    singImport() {
      this.$refs.singImport.submitForm()
    },
  },
}
</script>

<style lang="stylus">
#vehicle-manage
  width 100%
  .vehicle-manage-wrapper
    padding 20px 32px 32px 32px
    background white
    min-height calc(100vh - 180px)
  .el-tabs__header
    margin 0
  // .common-batch-import_title_info
  //   display flex
</style>
